import { configureDatadog } from '@lib/monitoring';
import { AuthorizationProvider } from '@vacasa/react-components-lib';
import React from 'react';
import ReactDOM from 'react-dom';
import { RecoilRoot } from 'recoil';
import { App } from './App';
import { OptimizelyWrapper } from './OptimizelyWrapper';
import { ReactQueryProvider } from './providers/ReactQueryProvider';
import reportWebVitals from './reportWebVitals';

configureDatadog();

ReactDOM.render(
    <React.StrictMode>
        <div id="estimator">
            <ReactQueryProvider>
                <RecoilRoot>
                    <AuthorizationProvider>
                        <OptimizelyWrapper>
                            <App />
                        </OptimizelyWrapper>
                    </AuthorizationProvider>
                </RecoilRoot>
            </ReactQueryProvider>
        </div>
    </React.StrictMode>,
    document.getElementById('jsapp-estimator-app'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
